/** Jogi oldalak — szinkron: backend/data/default_legal_pages.json (revision 4) */
export const LEGAL_OPERATOR = {
  "brand": "AutoPark",
  "companyName": "Giliczó Benjámin Tibor EV.",
  "seat": "6237 Kecel, Közvágóhíd utca 18.",
  "registry": "Egyéni vállalkozó — azonosítás adószám alapján (cégjegyzékszám nem alkalmazható).",
  "taxNumber": "90073335-1-23",
  "email": "info@autoparks.hu",
  "website": "autoparks.hu",
  "effectiveDate": "2026. október 26."
};

export const TERMS_SECTIONS = [
  {
    "title": "1. Általános rendelkezések",
    "body": [
      "Jelen Általános Szerződési Feltételek (a továbbiakban: ÁSZF) szabályozzák az AutoPark online használtautó-marketplace (a továbbiakban: Platform) használatát, valamint a Platform üzemeltetője (a továbbiakban: Szolgáltató) és a regisztrált felhasználók (a továbbiakban: Felhasználó) közötti jogviszonyt.",
      "A Platformot üzemeltető adatai: {companyName}, székhely: {seat}, adószám: {taxNumber}. {registry} Kapcsolat: {email}.",
      "A Platform használatával (regisztrációval, böngészéssel, hirdetés feladásával, kredit vásárlással) a Felhasználó elfogadja jelen ÁSZF-et. Ha nem ért egyet, ne használja a Platformot.",
      "A jelen ÁSZF-re a magyar jog az irányadó. A Platform igénybevétele 18. életévet betöltött, cselekvőképes természetes személyek és gazdálkodó szervezetek (pl. egyéni vállalkozó, cég) számára szól."
    ],
    "list": []
  },
  {
    "title": "2. Fogalmak",
    "body": [],
    "list": [
      "Eladó: olyan regisztrált Felhasználó, aki gépjármű-hirdetést ad fel.",
      "Üzleti felhasználó (kereskedő): gazdálkodó szervezetként vagy kereskedelmi forgalmú eladóként a Platformot használó Eladó — ugyanazon ÁSZF és kreditárazás alatt, külön aláírt hirdetési helycsomag-szerződés nélkül, hacsak a Szolgáltató ezt külön írásban nem köti meg.",
      "Vevő / látogató: a Platformot böngésző vagy érdeklődő személy (regisztráció nem minden funkcióhoz kötelező).",
      "Hirdetés: az Eladó által feltöltött gépjármű-adatok, képek, leírások és kapcsolódó tartalmak.",
      "Kredit: a Platformon belül felhasználható egység (vásárlással, promócióval vagy ajándékkal szerzett), amely hirdetésfeladásra, napi fenntartásra és kiegészítő szolgáltatásokra fordítható.",
      "Kiegészítő szolgáltatás: pl. 360° megjelenítés, AI háttércsere, AI ügyfélszolgálat, kiemelés, TOP rangsor, Meta hirdetés-kérés, statisztika — a Platformon feltüntetett kreditárakon."
    ]
  },
  {
    "title": "3. Regisztráció és fiók",
    "body": [
      "Eladói funkciók (hirdetésfeladás, fiók, kreditek) regisztrációhoz és bejelentkezéshez kötöttek. A Felhasználó köteles valós adatokat megadni, jelszavát bizalmasan kezelni, és haladéktalanul jelezni a Szolgáltatónak, ha fiókjának jogosulatlan használatát észleli.",
      "A Szolgáltató jogosult a regisztrációt megtagadni, a fiókot felfüggeszteni vagy törölni, ha a Felhasználó megsérti az ÁSZF-et, jogellenes tartalmat közzétesz, vagy visszaél a Platformmal.",
      "Google vagy más harmadik fél által biztosított bejelentkezés esetén a Felhasználó a harmadik fél feltételeit is elfogadja.",
      "A fiók személyes vagy szervezeti használatra szól; a hozzáférési adatokat harmadik félnek átadni vagy több fiókot visszaélés céljából létrehozni tilos."
    ],
    "list": []
  },
  {
    "title": "4. A szolgáltatás jellege",
    "body": [
      "Az AutoPark elsősorban technikai közvetítő: lehetőséget biztosít hirdetések közzétételére és megtekintésére. A Szolgáltató nem részesedője az Eladó és a Vevő közötti adásvételi szerződésnek, nem minősül autókereskedőnek kizárólag jelen ÁSZF alapján, és nem vizsgálja folyamatosan a hirdetések valóságtartalmát — ugyanakkor moderálhat, jóváhagyhat vagy eltávolíthat tartalmat.",
      "A hirdetések jóváhagyása adminisztrátori ellenőrzésen eshet át. A Szolgáltató nem garantálja, hogy minden hirdetés azonnal megjelenik, és nem garantál konkrét megtekintésszámot vagy eladást.",
      "A Szolgáltató és a Felhasználó között online szolgáltatási szerződés jön létre az ÁSZF elfogadásával és a szolgáltatás igénybevételével; külön írásbeli szerződés csak akkor szükséges, ha azt a felek kifejezetten megkötik."
    ],
    "list": []
  },
  {
    "title": "5. Eladók kötelezettségei és hirdetési szabályok",
    "body": [
      "Az alábbi szabályok megsértése esetén a Szolgáltató a hirdetést elutasíthatja, törölheti vagy a fiókot korlátozhatja."
    ],
    "list": [
      "Csak olyan gépjárművet hirdethet, amely felett értékesítési joggal rendelkezik.",
      "Egy adott járműről egyidejűleg egy aktív hirdetés adható fel; duplikált hirdetés vagy fiókokkal való megkerülés tilos.",
      "A hirdetésben szereplő adatok (ár, futásteljesítmény, műszaki állapot, felszereltség stb.) valósak és nem megtévesztőek; a bruttó vételár feltüntetése ajánlott.",
      "A feltöltött fotók/videók az adott autóról készültek; tilos más jármű, más portál vízjele, vagy félrevezető szerkesztés.",
      "Tilos más hirdetési oldalra mutató linket elhelyezni a hirdetésben, valamint jogellenes, megtévesztő vagy jó erkölcsbe ütköző tartalmat közzétenni.",
      "Az Eladó betartja a hatályos magyar jogot (fogyasztóvédelem, adózás, kötelező okmányok stb.).",
      "Az Eladó felel az érdeklődőkkel folytatott kommunikációért; az AI ügyfélszolgálat kiegészítő, nem helyettesíti az Eladó jogi kötelezettségeit."
    ]
  },
  {
    "title": "6. Vevők és látogatók",
    "body": [
      "A Platformon található információk tájékoztató jellegűek. Adásvétel előtt a Vevőnek saját felelősségére kell ellenőriznie az autót, okmányokat és szerződési feltételeket.",
      "Érdeklődés, üzenet, kedvencek használata során megadott adatokat az Adatvédelmi tájékoztató szerint kezeljük."
    ],
    "list": []
  },
  {
    "title": "7. Díjazás, kreditek, fizetés",
    "body": [
      "A hirdetésfeladás, napi fenntartás és kiegészítő szolgáltatások díjait kreditben kell rendezni, kivéve, ha a Platform máshogy jelzi. Az aktuális kreditárak a /kreditek és /szolgaltatasok oldalakon, valamint a fiókban láthatók; ezek az ÁSZF elválaszthatatlan részét képezik, ha ott megjelennek.",
      "Kreditcsomag vásárlás online fizetési szolgáltatón (Stripe) keresztül történhet. A fizetés lebonyolítására a fizetési szolgáltató feltételei is vonatkoznak. A vásárlásról elektronikus számlát állítunk ki a Felhasználó által megadott adatok alapján, a hatályos számviteli és adójogszabályok szerint.",
      "A kredit nem pénz, nem kamatozik. Másra átruházása a Platformon belül csak a Szolgáltató által biztosított funkciókkal (pl. ajándékozás) lehetséges. A kredit készpénzre történő visszaváltása általában nem biztosított, kivéve, ha azt külön jogszabály (pl. fogyasztói elállás) vagy írásbeli megállapodás előírja.",
      "Ha az Eladó kreditje elfogy, a hirdetés szünetelhet vagy lekerülhet a nyilvános kínálatból. A napi fenntartási díj és az opcionális kiegészítők (pl. részletes statisztika) levonása automatikus lehet.",
      "A Szolgáltató jogosult promóciós kreditet (pl. regisztrációs ajándék, teljesítménygarancia jóváírás, pilot partnerség) jóváírni. A promóció feltételeit (időtartam, minimum egyenleg, felhasználhatóság) a Platform vagy e-mail útján közli; a Szolgáltató jogosult a promóciót módosítani vagy visszavonni előzetes tájékoztatással, ha az nem érinti már jogszerűen megszerzett, kifizetett kreditcsomagokat."
    ],
    "list": []
  },
  {
    "title": "8. Előfizetés, elállás (fogyasztó)",
    "body": [
      "A Felhasználó havi vagy éves kreditcsomag-előfizetést vagy kereskedői előfizetést indíthat a /kreditek oldalon. Az előfizetés díja és a jóváírt kredit mennyisége a választott csomag szerint kerül megállapításra. Lemondás a fiókban vagy a Platformon biztosított felületen kezdeményezhető; a már kifizetett időszakra járó szolgáltatás a lemondás szabályai szerint marad érvényben (pl. időszak végéig).",
      "Fogyasztónak minősülő Felhasználó (természetes személy, aki nem üzleti célból jár el) a kreditcsomag egyszeri online vásárlása esetén — a fogyasztó és a vállalkozás közötti szerződések részletes szabályairól szóló 45/2014. (II. 26.) Korm. rendelet alapján — 14 napon belül elállhat, ha a teljesítés (kredit jóváírása) még nem kezdődött meg, vagy a jogszabály szerinti egyéb feltételek fennállnak.",
      "Ha a Felhasználó a vásárláskor kifejezetten kéri a kredit azonnali jóváírását és a szolgáltatás megkezdését a 14 napos elállási határidő lejárta előtt, tudomásul veszi, hogy az elállási jog a teljesítés megkezdését követően a jogszabály szerinti módon korlátozódhat; a felhasznált kredit ellenértékének arányos elszámolása alkalmazandó.",
      "Elállás, panasz: írásban a {email} címre. A Szolgáltató a beérkezett fogyasztói panaszt érdemben megvizsgálja."
    ],
    "list": []
  },
  {
    "title": "9. Kiegészítő és AI szolgáltatások",
    "body": [
      "A 360° megjelenítés, AI háttércsere, AI ügyfélszolgálat, kiemelés, TOP rangsor, Meta hirdetés-kérés, Facebook organikus megosztás-kérés, statisztika és egyéb kiegészítők technikai vagy manuális szolgáltatások; eredményük függ a feltöltött anyag minőségétől, a rendelkezésre álló rendszerektől és — Meta esetén — a külső hirdetési platform szabályaitól.",
      "A Meta hirdetés kiegészítő a Platformon a kredit díj a szolgáltatás-kérés és adminisztráció megfizetésére vonatkozik; a Meta (Facebook/Instagram) oldalon futó kampány költsége külön, az Eladó és a kampány indításának feltételei szerint.",
      "Az AI által generált szövegek, címkék vagy válaszok hibásak vagy hiányosak lehetnek. Döntés előtt mindig ellenőrizd a tartalmat. A Szolgáltató nem vállal felelősséget az AI kimenetéből eredő kárért, ha azt az Eladó ellenőrizetlenül használja."
    ],
    "list": []
  },
  {
    "title": "10. Lista, rangsor és kiemelések",
    "body": [
      "A hirdetések alapértelmezett rendezése és szűrési beállításai a Platformon érhetők el. A fizetős kiegészítők (pl. kiemelés a listában, TOP rangsorolás) a hirdetés megjelenését vagy rangsorbeli prioritását befolyásolhatják; a pontos hatás a /kreditek és /szolgaltatasok oldalon és a kiegészítő leírásában szerepel.",
      "A TOP rangsorolás erősebb prioritást ad, mint a vizuális listakiemelés. Több kiemelt hirdetés esetén a sorrend a Platform aktuális szabályai szerint alakul (pl. aktiválás ideje, szűrők).",
      "A Szolgáltató nem garantál fix helyezést minden keresésben; a rangsor a Felhasználói viselkedéstől és technikai tényezőktől is függhet."
    ],
    "list": []
  },
  {
    "title": "11. Szellemi tulajdon és adatbázis",
    "body": [
      "A Platform designja, szoftvere, védjegyei a Szolgáltató vagy partnerei tulajdonát képezik. A hirdetés feltöltésével az Eladó nem adja át ezeket, de a Szolgáltatónak nem kizárólagos, díjmentes jogot biztosít a tartalom Platformon való megjelenítésére, tárolására, technikai feldolgozására (pl. képméretezés, AI feldolgozás) és promóciójára a szolgáltatás nyújtása érdekében.",
      "A Platform adatbázisának, hirdetéslista tartalmának automatizált, üzleti célú letöltése, másolása vagy újra közzététele (scraping) a Szolgáltató előzetes írásbeli engedélye nélkül tilos."
    ],
    "list": []
  },
  {
    "title": "12. Felelősség korlátozása",
    "body": [
      "A Platform „adott állapotban” érhető el. A Szolgáltató törekszik a folyamatos működésre, de nem garantálja a megszakításmentes elérhetőséget.",
      "A Szolgáltató nem felel az Eladó és Vevő közötti szerződés teljesítéséért, a hirdetés tartalmáért, a gépjármű műszaki állapotáért, valamint közvetett károkért (elmaradt haszon stb.), kivéve, ha azt kogens jogszabály megállapítható sérelem esetén kizárja.",
      "A Felhasználó kártérítési kötelezettséget vállal, ha a Platform használatával, hibás adatszolgáltatással vagy jogellenes tartalommal kárt okoz a Szolgáltatónak vagy harmadik félnek."
    ],
    "list": []
  },
  {
    "title": "13. Bejelentés, moderálás",
    "body": [
      "A Szolgáltató jogosult a hirdetéseket jóváhagyni, módosítást kérni, elutasítani vagy törölni, ha azok az ÁSZF-be, jogszabályba ütköznek, vagy bejelentés érkezik róluk.",
      "Jogellenes vagy szabályt sértő hirdetés, tartalom bejelentése: {email} címre, a hirdetés azonosítójával és rövid leírással. A Szolgáltató ésszerű határidőn belül megvizsgálja a bejelentést.",
      "A moderálási döntésről az érintett Eladót e-mailben vagy a fiókban értesítjük, ha technikailag lehetséges. A Felhasználó panasszal élhet a döntéssel szemben a panaszkezelési szabályok szerint."
    ],
    "list": []
  },
  {
    "title": "14. Üzleti felhasználók",
    "body": [
      "Az üzleti felhasználók (kereskedők) ugyanazon ÁSZF és kreditárazás alatt használják a Platformot; külön aláírt hirdetési helycsomag nem szükséges, hacsak a felek másként nem állapodnak meg.",
      "A Szolgáltató a díjakat és kiegészítőket átláthatóan, a /kreditek oldalon teszi közzé. Az Európai Parlament és a Tanács (EU) 2019/1150 rendelete értelmében az üzleti felhasználók panasszal fordulhatnak a {email} címhez; a Szolgáltató ésszerű határidőn belül válaszol.",
      "A fiók felfüggesztése vagy megszüntetése esetén — ha az nem azonnali, súlyos jogsértés miatt szükséges — a Szolgáltató törekszik az indok rövid ismertetésére e-mailben."
    ],
    "list": []
  },
  {
    "title": "15. Panaszkezelés, elérhetőség",
    "body": [
      "Panasz, kérdés, elállás: {email}. A Szolgáltató a beérkezett írásbeli panaszt legkésőbb 30 napon belül érdemben megvizsgálja és válaszol.",
      "Fogyasztónak minősülő Felhasználó jogvitája esetén békéltető testülethez fordulhat (pl. Budapesti Békéltető Testület, 1016 Budapest, Krisztina krt. 99.; levelezési cím: 1253 Budapest, Pf. 10.), valamint hatósághoz a hatályos jogszabályok szerint."
    ],
    "list": []
  },
  {
    "title": "16. Módosítás, hatály",
    "body": [
      "A Szolgáltató jogosult az ÁSZF-et módosítani. A lényeges változásokról — amennyiben lehetséges — legalább 15 nappal a hatálybalépés előtt a Platformon ( /aszf ) vagy e-mailben tájékoztat. A módosítás hatálya alatt a Platform további használata ráutaló magatartásnak minősülhet, ha a jogszabály ettől eltérően nem rendelkezik; üzleti felhasználó a lényeges díj- vagy feltételváltozás esetén jogosult a szolgáltatás használatát megszüntetni.",
      "Hatályos: {effectiveDate}."
    ],
    "list": []
  }
];

export const PRIVACY_SECTIONS = [
  {
    "title": "1. Adatkezelő",
    "body": [
      "Az AutoPark Platform személyes adatainak kezelője:",
      "{companyName}, székhely: {seat}, adószám: {taxNumber}, e-mail: {email}.",
      "Jelen tájékoztató a GDPR (EU 2016/679) és az Infotv. (2011. évi CXII. törvény) alapján készült."
    ],
    "list": []
  },
  {
    "title": "2. Kezelt adatok köre",
    "body": [],
    "list": [
      "Regisztráció / fiók: név, e-mail cím, jelszó (titkosított formában), telefonszám (opcionális), profilkép (pl. Google bejelentkezés esetén).",
      "Eladói hirdetés: gépjármű adatai, helyszín (megye, város), leírás, képek, videók, felszereltség, ár.",
      "Használati adatok: megtekintések, érdeklődések, üzenetek, kedvencek, kredit tranzakciók, kiegészítők aktiválása.",
      "Fizetés: a kártyafizetést a fizetési szolgáltató (pl. Stripe) bonyolítja; mi általában nem tároljuk a teljes bankkártyaszámot. Számlázási név és cím a számla kiállításához.",
      "Üzenet-email értesítés: regisztrációkor adott hozzájárulás esetén a regisztrált e-mail címre értesítés új chat üzenetről.",
      "Technikai adatok: IP-cím, böngésző típusa, eszközadatok, naplóbejegyzések, sütik / helyi tároló (lásd lent)."
    ]
  },
  {
    "title": "3. Adatkezelés célja és jogalapja",
    "body": [],
    "list": [
      "Szolgáltatás nyújtása, fiók kezelése — szerződés teljesítése (GDPR 6. cikk (1) b)).",
      "Hirdetések megjelenítése, érdeklődés továbbítása — szerződés / jogos érdek (6. cikk (1) b), f)).",
      "Számlázás, kredit elszámolás — jogi kötelezettség / szerződés (6. cikk (1) c), b)).",
      "Platform biztonság, visszaélés megelőzés — jogos érdek (6. cikk (1) f)).",
      "Statisztika, fejlesztés (pl. látogatottság, PostHog) — hozzájárulás (6. cikk (1) a)), visszavonható a süti beállításokban.",
      "Üzenet-email értesítés — hozzájárulás (6. cikk (1) a)), visszavonható a fiók törlésével vagy írásban az adatkezelőnél.",
      "Marketing hírlevél — csak külön hozzájárulással (6. cikk (1) a))."
    ]
  },
  {
    "id": "cookies",
    "title": "4. Sütik és helyi tároló (localStorage)",
    "body": [
      "Az ePrivacy irányelv és a GDPR szerint a nem szükséges sütikhez és hasonló technológiákhoz előzetes, önkéntes hozzájárulás szükséges. Az oldal első látogatásakor süti-sáv jelenik meg: „Elfogadom az összeset”, „Csak szükséges” és „Beállítások” egyenrangú választási lehetőséggel. A hozzájárulást bármikor módosíthatod a lábléc „Süti beállítások” linkjén.",
      "Szükséges: bejelentkezési munkamenet (JWT token a localStorage-ban), a süti-választásod megjegyzése (autopark_cookie_consent). Ezek nélkül a fiók és a választásod nem marad meg megbízhatóan.",
      "Funkcionális (csak hozzájárulással): téma (világos/sötét), kedvencek listája, egyes UI-beállítások a böngésző helyi tárolójában.",
      "Statisztika (csak hozzájárulással): anonim látogatói azonosító (autopark_visit_sid) és oldalmegtekintés-jelzés a saját szerverünkre; PostHog (posthog.com, USA) — oldalhasználat, munkamenet-elemzés. PostHog csak statisztikai hozzájárulás után töltődik be.",
      "Marketing: jelenleg nem használunk marketing célú sütit vagy remarketing pixelt."
    ],
    "list": []
  },
  {
    "title": "5. Adattovábbítás, adatfeldolgozók",
    "body": [
      "Személyes adatot adhatunk át olyan partnereknek, akik a szolgáltatást technikailag biztosítják (tárhely, e-mail, fizetés, bejelentkezés, AI feldolgozás), szerződéses adatvédelmi kötelezettségek mellett.",
      "Lehetséges adatfeldolgozók köre: tárhely-/felhőszolgáltató, Stripe (fizetés), Google (OAuth bejelentkezés, ha használod), AI/LLM szolgáltató (pl. képelemzés, chatbot, ajánló — csak a szolgáltatáshoz szükséges tartalom).",
      "Az adat EU/EGT-n kívülre csak megfelelő garanciák mellett kerülhet (pl. standard szerződéses klauzulák), ha az adott szolgáltató ezt igényli."
    ],
    "list": []
  },
  {
    "title": "6. Megőrzési idő",
    "body": [
      "Fiók és hirdetés adatait a fiók fennállása alatt, illetve a jogi kötelezettségek (pl. számvitel) szerinti ideig őrizzük.",
      "Törölt fiók vagy hirdetés esetén az adatokat ésszerű határidőn belül töröljük vagy anonymizáljuk, kivéve, ha jogi igény érvényesítése vagy jogszabály miatt szükséges további megőrzés.",
      "Napló- és biztonsági adatokat általában korlátozott ideig (pl. 6–24 hónap) tároljuk."
    ],
    "list": []
  },
  {
    "title": "7. Érintetti jogok",
    "body": [
      "Kérheted adataidhoz való hozzáférést, helyesbítést, törlést, kezelés korlátozását, adathordozhatóságot, tiltakozást, valamint — ha hozzájáruláson alapul — a hozzájárulás visszavonását.",
      "Panaszt tehetsz a Nemzeti Adatvédelmi és Információszabadság Hatóságnál (NAIH): naih.hu.",
      "Kérelmeidet küldd a {email} címre; azonosítás után ésszerű határidőn belül válaszolunk."
    ],
    "list": []
  },
  {
    "title": "8. Biztonság",
    "body": [
      "Megfelelő technikai és szervezési intézkedéseket alkalmazunk (pl. titkosított kapcsolat, hozzáférés-szabályozás). Teljes biztonság azonban az interneten nem garantálható."
    ],
    "list": []
  },
  {
    "title": "9. Kiskorúak",
    "body": [
      "A Platform eladói szolgáltatásai 18 éven aluliak számára nem célozottak. Tudomásunkra jutása esetén töröljük a kiskorú adatait."
    ],
    "list": []
  },
  {
    "title": "10. Tájékoztató módosítása",
    "body": [
      "Jelen tájékoztatót frissíthetjük. A hatályos verzió mindig a Platformon érhető el.",
      "Utolsó frissítés: {effectiveDate}."
    ],
    "list": []
  }
];
